/**
 * Encode a string to URL-safe base64 format
 * This matches the Python implementation: urlsafe_base64_encode
 * Strips trailing newlines and equal signs
 * 
 * @param {string|number} value - The value to encode
 * @returns {string} - URL-safe base64 encoded string
 */
export function urlsafeBase64Encode(value) {
  // Convert value to string if it's a number
  const str = String(value);
  
  // Convert string to UTF-8 bytes, then to base64
  const base64 = btoa(unescape(encodeURIComponent(str)));
  
  // Make it URL-safe by replacing + with - and / with _
  // Also remove trailing = padding characters
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

/**
 * Decode a URL-safe base64 string
 * 
 * @param {string} encoded - The URL-safe base64 encoded string
 * @returns {string} - Decoded string
 */
export function urlsafeBase64Decode(encoded) {
  // Replace URL-safe characters back to standard base64
  let base64 = encoded
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  // Add padding if needed
  const padding = base64.length % 4;
  if (padding) {
    base64 += '='.repeat(4 - padding);
  }
  
  // Decode from base64 to string
  return decodeURIComponent(escape(atob(base64)));
}
